module.exports = __webpack_public_path__ + "images/hero-1.jpg?85631";